var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhmisLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 550,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m333.7 202.06c18.978 0 34.378 19.366 34.378 43.246 0 23.879-15.399 43.227-34.378 43.227-18.994 0-34.383-19.348-34.383-43.227 0-23.881 15.389-43.246 34.383-43.246zm91.678 98.983-14.584 126.07-88.554-126.07zm-154.19 57.309 90.64 131.27 83.354 30.22-189.62-262.56zm53.132 129.53-83.351 33.346 21.359-28.654s4.9528-4.9528-1.564-9.9036l-126.06-75.353 17.714-12.508s10.073-5.5519 3.8167-19.792l-19.453-40.634 37.513 3.1222s17.364 4.517 19.801-12.497l2.0776-18.761z",
    fill: "#f68e27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m300 46.92s9.0262-0.3521 13.549 7.6373l234.07 400.08s8.3337 23.61-14.586 24.299h-84.73l9.7149 18.761h77.094s18.757 0 29.88-20.142c0 0 9.0263-13.899-4.1707-36.122l-228.52-391.05s-9.3745-21.531-32.3-21.531v-0.0875c-22.918 0-32.302 21.544-32.302 21.544l-228.52 391.03c-13.189 22.231-4.163 36.115-4.163 36.115 11.112 20.153 29.868 20.153 29.868 20.153h139.61l9.7207-18.764h-147.24c-22.926-0.69253-14.592-24.303-14.592-24.303l234.07-400.07c4.5093-7.9874 13.543-7.6431 13.543-7.6431z",
    fill: "#195e9c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhmisLogo);
export default __webpack_public_path__ + "static/media/WHMIS_logo.7284bbb796f66ea6a593a5da924fef4f.svg";
export { ForwardRef as ReactComponent };